// extracted by mini-css-extract-plugin
export default {"ava":"Avatar_ava__XOE6P","icon":"Avatar_icon__O8zPi","activeSvg":"Avatar_activeSvg__MwCH-","active":"Avatar_active__pNmo6","placeHolderShimmer":"Avatar_placeHolderShimmer__DTtHX"};